module.exports = __webpack_public_path__ + "static/media/mob_alert_partner_white_x1.fb735184.png";